import React from "react";
import { Box, Typography } from "@mui/material";

const NoTrialsAssigned = () => {
    return (
        <Box
            sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                px: 4,
            }}
        >
            <Typography variant="h6">
                You are not assigned to any trial - please contact your trial administrator for assistance.
            </Typography>
        </Box>
    );
};

export default NoTrialsAssigned;
